import { CircularProgress, Divider, Grid, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import TablePaginatedEmail from 'widgets/Tables/TablePaginatedEmail';
import TableSimple from 'widgets/Tables/TableSimple';
import { CardGeneric } from '../components/CardGeneric';
import { API_GET_ALL_CREDENTIALS, API_GET_SEARCH_CREDENTIALS } from './apis';
import tableStyle from "configurations/styles/table";
import SearchCompany from './Forms/SearchCompany';
import { apiKey } from 'configurations/constant';
import AddCredentialEmailBtn from './Buttons/AddCredentialEmailBtn';
import { httpNotificador } from 'configurations/axios';
import EditCredentialEmailBtn from './Buttons/EditCredentialEmailBtn';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: "35px",
        paddingBottom: "7%",
        flexGrow: 1,
        paddingLeft: "3%",
        paddingRight: "3%",
    },
    headerBottons: {
        padding: "0.5%",
    },
    loader: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        height: "300px"
    }
}));


const Email = () => {

    const classesView = useStyles();
    const [update, setUpdate] = useState(0);
    const [paramSearch, setParamSearch] = useState("");
    const [foundCompany, setFoundCompany] = useState([]);

    const columns = [
        { title: "Cuenta de", field: "cuentaFrom", cellStyle: tableStyle.cellTable, width: "8%", },
        { title: "Host", field: "host", cellStyle: tableStyle.cellLeft, },
        { title: "Nombre", field: "nombre", cellStyle: tableStyle.cellLeft, },
        { title: "Username", field: "username", cellStyle: tableStyle.cellTable, },
        { title: "Editar", cellStyle: tableStyle.cellTable, render: rowData => <EditCredentialEmailBtn data={rowData} updateView={reload} /> },
    ];

    const requestConfig = {
        uri: API_GET_ALL_CREDENTIALS + 0 + "/" + 15,
        metodo: "get",
        body: null,
    };

    const reload = () => {
        setUpdate(1);
    };

    const getParam = (data) => {
        setParamSearch(data);
        if (data.length > 0) {
            searchCompany(data);
        } else {
            reload();
        }
    };

    const searchCompany = async (param) => {
        setUpdate(3);
        await httpNotificador
            .get(
                API_GET_SEARCH_CREDENTIALS +
                apiKey +
                "?parametroBusqueda=" +
                param
            )
            .then((response) => {
                if (response.status === 200) {
                    setFoundCompany(response.data);
                    setUpdate(2);
                }
            })
            .catch((exception) => {
                console.error({ exception });
            });
    };

    useEffect(() => {
        if (update === 1) {
            setUpdate(0);
        }
    }, [update]);

    const renderTable = () => {
        switch (update) {
            case 0:
                return (
                    <TablePaginatedEmail
                        title=""
                        columns={columns}
                        requestConfig={requestConfig}
                        seleccion={false}
                    />
                );

            case 1:
            case 3:
                return (
                    <div className={classesView.loader}>
                        <CircularProgress />
                    </div>
                );
            case 2:
                return (
                    <TableSimple
                        columns={columns}
                        data={foundCompany}
                        title=""
                        numberRowsPerPage={15}
                    />
                );
            default:
                break;
        }
    };

    return (
        <div className={classesView.root}>
            <CardGeneric>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        {<AddCredentialEmailBtn updateView={reload}
                        />}
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={9} className={classesView.headerBottons}>
                        {<SearchCompany backupParam={paramSearch} sendData={getParam} />}
                    </Grid>
                </Grid>
            </CardGeneric>
            {renderTable()}
        </div>
    );
}

export default Email;